import * as React from "react";

const CartWithWatch: React.FC = () => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 360.000000 351.000000"
            preserveAspectRatio="xMidYMid meet"
            className="tmp-svg-icon"
        >
            <g transform="translate(0.000000,351.000000) scale(0.100000,-0.100000)" stroke="none">
                <path
                    d="M2590 3460 c-373 -93 -628 -434 -607 -815 7 -126 26 -197 82 -310 80
-164 196 -280 360 -360 110 -55 182 -74 302 -82 243 -16 474 79 641 261 133
146 202 331 202 538 0 370 -266 697 -630 773 -97 20 -256 18 -350 -5z m350
-171 c106 -29 194 -81 276 -163 195 -195 239 -467 116 -716 -47 -96 -177 -230
-269 -278 -428 -224 -941 111 -910 592 7 106 23 161 72 255 83 157 232 274
405 316 86 21 223 18 310 -6z"
                />
                <path
                    d="M2700 2890 c0 -287 -8 -280 300 -280 l210 0 0 75 0 75 -177 2 -178 3
-3 158 -3 157 -74 0 -75 0 0 -190z"
                />
                <path
                    d="M73 2992 l-43 -3 0 -115 0 -114 223 0 222 0 220 -932 c149 -630 227
-942 240 -962 11 -17 32 -36 45 -43 20 -10 225 -13 922 -13 l897 0 35 30 c40
35 32 7 146 535 44 204 83 378 86 387 4 15 1 16 -28 7 -18 -5 -73 -16 -122
-24 -49 -8 -93 -18 -96 -22 -4 -5 -39 -158 -79 -342 -40 -184 -74 -338 -77
-342 -2 -4 -351 -7 -774 -7 l-770 0 -9 37 c-6 20 -71 299 -146 621 -75 322
-138 593 -141 603 -5 16 25 17 536 17 513 0 542 1 535 18 -17 39 -55 176 -55
198 l0 24 -538 0 -538 0 -38 173 c-21 94 -45 187 -53 205 -28 59 -48 63 -316
65 -133 1 -261 1 -284 -1z"
                />
                <path
                    d="M1062 494 c-87 -43 -136 -124 -136 -224 0 -144 106 -250 253 -250
159 0 277 148 242 305 -36 159 -213 242 -359 169z"
                />
                <path
                    d="M2550 507 c-49 -16 -133 -102 -148 -153 -30 -101 -9 -188 63 -259 71
-72 158 -93 259 -63 55 16 138 99 154 154 30 101 9 188 -63 259 -71 71 -166
93 -265 62z"
                />
            </g>
        </svg>
    );
};

export default CartWithWatch;
